import FormController from './form_controller';
import Events from '../classes/Events';
import axios from 'axios';

class LoginForm extends FormController {
  static targets = [
    'email',
    'password',
    'errorMessage'
  ]

  static values = {
    status: String
  }

  targetNames() {
    return LoginForm.targets;
  }

  async login() {
    const { data } = await axios.post('/users/sign_in/', {
      email: this.emailTarget.value,
      password: this.passwordTarget.value
    })
    if (data.error) {
      this.statusValue = 'error'
      this.errorMessageTarget.textContent = data.error.description;
      this.errorMessageTarget.classList.remove('t-hidden')
    } else {
      this.memberIsPremium = data.premium;
      this.statusValue = 'success'
      this.element.dispatchEvent(Events.submittedEvent);
    }
  }

  redirect() {
    if (this.memberIsPremium) {
      window.location.href = '/premium/'
    } else {
      window.location.href = '/'
    }
  }

}

export default LoginForm;
